import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from 'antd/es/modal';
import Button from './Button';

import { FormMode } from 'hooks/useForm';

const FormModal = ({ form, children, submitText, disabledButtons, closeText, onClose, ...rest }) => {
  const [show, setShow] = useState(false);

  const onCancel = useCallback(() => {
    setShow(false);
    if (typeof onClose === 'function') onClose();
  }, [onClose]);
  
  return (
    <Modal
      visible={[FormMode.create, FormMode.edit].includes(form.mode) || show}
      onCancel={onCancel}
      footer={(
        <>
          <Button key="back" onClick={onCancel} disabled={disabledButtons || form.isSubmitting}>
            {closeText}
          </Button>
          <Button key="submit" type="primary" onClick={() => form.submit(form.isSubmitting)} loading={form.isSubmitting} disabled={disabledButtons || form.isSubmitting}>
            {submitText}
          </Button>
        </>
      )}
      {...rest}
    >
      {children}
    </Modal>
  );
};

FormModal.propTypes = {
  form: PropTypes.object.isRequired,
  children: PropTypes.node,
  submitText: PropTypes.string.isRequired,
  closeText: PropTypes.string,
  onClose: PropTypes.func,
};

FormModal.defaultProps = {
  closeText: 'Cancel',
};

export default FormModal;
